import { createSlice } from '@reduxjs/toolkit'

const defaultFilters = {
  lessorId: '',
  lessorName: '',
  companyId: '',
  companyCode: '',
  vendorId: '',
  vendorCode: '',
  contractNumber: '',
}

export const dashboard = createSlice({
  name: 'dashboard',
  initialState: {
    filters: defaultFilters,
  },
  reducers: {
    setFilters(state, { payload }) {
      state.filters = payload
    },
    updateFilters(state, { payload }) {
      state.filters = {
        ...state.filters,
        ...payload,
      }
    },
    clearFilters(state) {
      state.filters = defaultFilters
    },
  },
})

export const { setFilters, updateFilters, clearFilters } = dashboard.actions

export default dashboard.reducer
